__turbopack_context__.v({
  "collapse": "Default-module__zEUhgq__collapse",
});
